import { createState, State, useState } from '@hookstate/core';
import { IUpdateRawQueryList } from '@models/Update.model';

import { getEquipmentUpdates } from '@services/queries/equipments';
import { createContext, useEffect } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { useParams } from 'react-router-dom';
import { UpdatesRaw } from './Updates.raw';

interface IAssetUpdatesContext {
  search: State<string>;
  updateStatusId: State<string | null>;
  updatesQuery?: UseQueryResult<IUpdateRawQueryList[], unknown>;
}

export const AssetUpdatesContext = createContext<IAssetUpdatesContext>({
  search: createState<string>(''),
  updateStatusId: createState<string | null>(null),
});

export const UpdatesQuery = () => {
  const params = useParams<{ equipmentId: string }>();

  const search = useState<string>('');
  const updateStatusId = useState<string | null>(null);

  const updatesQuery = useQuery(
    ['equipments', params.equipmentId, 'updateStatuses', search.get()],
    () =>
      getEquipmentUpdates({
        equipmentId: params.equipmentId,
        search: search.get(),
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    updatesQuery.refetch();
  }, [search.get()]);

  return (
    <AssetUpdatesContext.Provider
      value={{
        search,
        updateStatusId,
        updatesQuery,
      }}
    >
      <UpdatesRaw />
    </AssetUpdatesContext.Provider>
  );
};
